import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import thalamosMark from "../../assets/img/thalamos-mark.svg";

/** Haven's mark and name, at the head of every guest page. */
export const GuestBrand = () => {
  const { t } = useTranslation();

  return (
    <Stack direction="row" spacing={1.5} alignItems="center">
      {/* Decorative: the product's name is in the text beside it. */}
      <Box
        component="img"
        src={thalamosMark}
        alt=""
        sx={{ width: 32, height: "auto" }}
      />
      <Typography variant="h6" component="p">
        {t("app.name")}
      </Typography>
    </Stack>
  );
};
